import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=b3efaaf0&scoped=true&"
import script from "./Tour.vue?vue&type=script&lang=js&"
export * from "./Tour.vue?vue&type=script&lang=js&"
import style0 from "./Tour.vue?vue&type=style&index=0&id=b3efaaf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3efaaf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3efaaf0')) {
      api.createRecord('b3efaaf0', component.options)
    } else {
      api.reload('b3efaaf0', component.options)
    }
    module.hot.accept("./Tour.vue?vue&type=template&id=b3efaaf0&scoped=true&", function () {
      api.rerender('b3efaaf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tour.vue"
export default component.exports